export function getMimeTypeFromDataURL(dataURL : string) {
	return (dataURL.substring(dataURL.indexOf(':') + 1, dataURL.indexOf(';')));
};
export const measure = (() => {
	const measures = <Map<string, number>>new Map;
	return ((what : string, useLogger : boolean = false) => {
		let t0 : number | undefined = measures.get(what);
		if (t0) {
			var t1 = performance.now();
			var dt = t1 - t0;
			measures.delete(what);
			if (useLogger !== false) {
				console.warn(`<measure name='${ what }'>${ dt }</measure>`);
			}
			return (dt);
		} else {
			t0 = performance.now();
			measures.set(what, t0);
			return (0);
		}
	});
})();
export function formatRequest(
	URL        : string,
	parameters : { [ key : string] : string } = {}
) {
	const finalParameters : Record<string, string | number | boolean>= {};
	if (URL.includes('?')) {
		let [ baseURL, params ] = URL.split('?');
		if (!params) {
			params = '';
		}
		for (const [ k, v ] of params.split('&').filter(x => x).map(x => x.split('='))) {
			finalParameters[<string>k] = <string>v;
		}
		URL = baseURL || '';
	}
	Object.assign(finalParameters, parameters);
	const parametersKV = Object.entries(finalParameters);
	return (URL + '?' + parametersKV.map((x) => {
		return (x[0] + '=' + x[1]);
	}).join('&'));
};
// Retrieve a data indexed by quantity
// used column is closest column with quantity < to current quantity
// Exemple:
// const data = {
// 	0  : 0,      1  : 1,
// 	2  : 12,     3  : 103,
// 	4  : 1004,   5  : 10005,
// 	10 : 100006, 15 : 1000007,
// 	20 : 10000008
// };
// console.log({
// 	0  : getDataInFunctionOfQuantity(data, 0),
// 	1  : getDataInFunctionOfQuantity(data, 1),
// 	2  : getDataInFunctionOfQuantity(data, 2),
// 	4  : getDataInFunctionOfQuantity(data, 4),
// 	8  : getDataInFunctionOfQuantity(data, 8),
// 	16 : getDataInFunctionOfQuantity(data, 16)
// });
// Should display
// {
// 	0  : 0,
// 	1  : 1,
// 	2  : 12,
// 	4  : 1004,
// 	8  : 10005,
// 	16 : 1000007
// }
export function getDataInFunctionOfQuantity<T>(
	store    : Record<number, T>,
	quantity : number
) {
	try {
		const couples = (
			Object.entries(store)
			.map(x => <[ number, T ]>[ parseInt(x[0]), x[1] ])
			.filter(x => x[0] <= quantity)
		);
		const first = <[ number, T ]>couples.shift();
		const min   = couples.reduce((a, c) => {
			return ((a[0] > c[0]) ? a : c);
		}, first);
		return (min[1]);
	} catch (e : unknown) {
		throw E.bindFromUnknown('', {
			store,
			quantity
		}, e);
	}
};
export function createPromisePack<T>() {
	let resolveReference : (result : T) => void = () => {};
	let rejectReference  : (error : Error) => void = () => {};
	const promise = new Promise<T>((resolve, reject) => {
		resolveReference = resolve;
		rejectReference  = reject;
	});
	return ({
		promise,
		resolve : resolveReference,
		reject  : rejectReference
	});
};
/**
 * Call $fn each $frequencyInMs while it's return is not true
 * If $fn return true poll return true too, if timeout is reached return false
 **/
export async function poll(
	fn            : () => (boolean | Promise<boolean>),
	frequencyInMs : number,
	timeoutInMs   : number
) {
	const ppack = createPromisePack();
	const timeoutId = setTimeout(() => {
		clearInterval(intervalId);
		ppack.resolve(false);
	}, timeoutInMs);
	const intervalId = setInterval(async () => {
		try {
			if (await fn()) {
				clearTimeout(timeoutId);
				clearInterval(intervalId);
				ppack.resolve(true);
			}
		} catch (error : unknown) {
			E.userAssert(error instanceof Error, 'Error is not an error!', {
				error
			});
			ppack.reject(error);
		}
	}, frequencyInMs);
	return (await ppack.promise);
};
import * as E from './errors';
